module.exports = __webpack_public_path__ + "static/media/loginLogo.998de174.png";